import React from "react";
import "./About.css";
import { Flex, Header, SafeArea } from "../../components/layout";
import { Image, Text, Title } from "../../components/ui";

import AboutImage from "../../assets/images/landing/about.jpg";

function About() {
  return (
    <SafeArea className="About">
      <Flex type="col-center" gap={80}>
        <Flex type="col-center" gap={50}>
          <Header
            title="Nous connaitre"
            text="Nous sommes heureux de partager avec vous notre amour de l'humain et de la nature."
          />
          <Image src={AboutImage} alt="Illustration" />
        </Flex>
        <Flex type="center-start" gap={50} className="wrapper">
          <Flex type="col-center" gap={40} className="container">
            <Title level="h3">Marc</Title>
            <Flex type="col-center" gap={10}>
              <Text size="xs">
                Mes 20 ans d’expérience dans l’accompagnement d’ingénieurs et de
                managers m’ont permis de développer ma capacité d’écoute et de
                soutenir chacun sur le chemin de sa réalisation.
              </Text>
              <Text size="xs">
                Passionné de randonnée et d’orientation, j’anime depuis plus de
                dix ans des sorties en montagne en toutes saisons tout en me
                formant régulièrement pour parfaire mon expertise.
              </Text>
              <Text size="xs">
                Je suis animé par mon envie de collaborer et de m’engager en
                m’appuyant sur mon énergie et ma fiabilité.
              </Text>
            </Flex>
          </Flex>
          <Flex type="col-center" gap={40} className="container">
            <Title level="h3">Laurence</Title>
            <Flex type="col-center" gap={10}>
              <Text size="xs">
                Ma carrière en tant qu’enseignante spécialisée et kinésiologue
                m’a amenée à développer mes capacités d’écoute et d’attention
                aux autres.
              </Text>
              <Text size="xs">
                Passionnée par l’humain et son bien-être, j’enrichis sans cesse
                mes connaissances afin d’accompagner chacun dans l’accès à
                l’harmonie tête / cœur / corps.
              </Text>
              <Text size="xs">
                Je suis animée par mon amour de la vie et des autres,
                l’espérance est mon levier.
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </SafeArea>
  );
}

export default About;
